import React from 'react';
import styled from 'styled-components';
import heart_icon from '../../../../images/heart-icon.png';
import heart_icon_on from '../../../../images/heart_icon.png';
import comment_icon from '../../../../images/comment_icon.png';
import { Link } from 'react-router-dom';
import LottieLoader from 'components/containers/common/LottieLoader';
import likeAnimation from 'images/lottiefile/like_animation_red.json'

function HeartIcon({ click }) {
  return (
    <HeartIconTag onClick={click}>
      <img src={heart_icon} alt={'like off'}></img>
    </HeartIconTag>
  );
}
function HeartIconOn({ click }) {
  return (
    <HeartIconTag onClick={click}>
      <img src={heart_icon_on} alt={'like on'}></img>
    </HeartIconTag>
  );
}

const lottieOptions = {
  loop: false,
  autoplay: true,
  renderer: 'svg',
  animationData: likeAnimation
}

const lottieStyle = {
  position: 'absolute',
  top: '-100%',
  left: '-100%',
  transform: 'translate(10%, 10%)',
  width: 'calc(100vw * (50.2 / 375))',
  height: 'calc(100vw * (45.8 / 375))'
}

export default function CommunityIconbtnpage(props) {
  // 하트 버튼 클릭
  function likeClick() {
    props.likedataSubmit(props.item.no);
  }
  function nulikeClick() {
    props.likedeldataSubmit(props.item.no);
  }
  
  return (
    <IconList
      borderwidth={props.borderwidth}
      borderline={props.borderline}
      margintop={props.margintop}
    >
      <IconListAlign>
        {props.item.liked_post === false ? 
        (
          <HeartIcon click={likeClick} />
        ) : (
          props.isLikeAnimation && props.currentPostNo === props.item.no?
          <AnimationBlock>
            <LottieLoader lottieFile={likeAnimation}  lottieOptions={lottieOptions} style={lottieStyle}/>
          </AnimationBlock>
          :
          <HeartIconOn click={nulikeClick} />
        )}
        <TotalCount>{props.item.total_like}</TotalCount>
      </IconListAlign>
      <IconListAlign>
        <Commlink
          to={`/campaign/${props.campaign_no}/post/${props.no}`}
        >
          <CommentIcon>
            <img src={comment_icon} alt={'comment icon'}/>
          </CommentIcon>{' '}
          <TotalCount>{props.length ? props.length : 0}</TotalCount>
        </Commlink>
      </IconListAlign>
    </IconList>
  );
}

const IconList = styled.ul`
  display: flex;
  align-items: center;
  padding: calc(100vw * (11 / 375)) 0;
  border: ${(props) => props.borderline};
  border-width: ${(props) => props.borderwidth};
  margin-top: ${(props) => props.margintop};
`;

const IconListAlign = styled.li`
  display: flex;
  align-items: center;
`;
const Commlink = styled(Link)`
  display: flex;
  align-items: center;
`;
const HeartIconTag = styled.span`
  display: block;
  width: calc(100vw * (20.1 / 375));
  height: calc(100vw * (18.9 / 375));
`;
const CommentIcon = styled.span`
  display: block;
  width: calc(100vw * (17.9 / 375));
  height: calc(100vw * (17.9 / 375));
  margin-left: calc(100vw * (10 / 375));
`;
const TotalCount = styled.em` 
  font-size: calc(100vw * (9 / 375));
  font-weight: 500;
  color: #7f7f7f;
  margin-left: calc(100vw * (3.5 / 375));
`;

const AnimationBlock = styled.div`
  position: relative;
  width: calc(100vw * (20.1 / 375));
  height: calc(100vw * (18.9 / 375));
`;